import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToTop = (e: React.MouseEvent) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-secondary-100 border-t border-background-200/70">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-lg font-semibold text-foreground-900 mb-4">
              <a href="/about" className="hover:text-primary-600 transition-colors">关于我们</a>
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              正太漫画专题网站，致力于为漫画爱好者与创作者提供优质的正太风格漫画作品推荐、绘画教程与同人创作资源。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-lg font-semibold text-foreground-900 mb-4">内容分类</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/category/zuopin-tuijian" onClick={scrollToTop} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  作品推荐
                </Link>
              </li>
              <li>
                <Link to="/category/huihua-jiaocheng" onClick={scrollToTop} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  绘画教程
                </Link>
              </li>
              <li>
                <Link to="/category/tongren-chuangzuo" onClick={scrollToTop} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  同人创作
                </Link>
              </li>
              <li>
                <Link to="/category/fengge-jiexi" onClick={scrollToTop} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  风格解析
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg font-semibold text-foreground-900 mb-4">热门文章</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/article/zhengtaifengge-rumen-zhinan" onClick={scrollToTop} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  正太漫画风格入门指南
                </Link>
              </li>
              <li>
                <Link to="/article/renwu-bili-sheji-jiqiao" onClick={scrollToTop} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  人物比例设计技巧
                </Link>
              </li>
              <li>
                <Link to="/article/jingdian-zhengtai-manga-pan-dian" onClick={scrollToTop} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  经典作品大盘点
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg font-semibold text-foreground-900 mb-4">联系我们</h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i>
                <span>contact@zhengtai-manga.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-weibo-line text-primary-500"></i>
                <span>@正太漫画研究所</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-bilibili-line text-primary-500"></i>
                <span>正太漫画官方账号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 正太漫画 Zhengtai Manga. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="/about" onClick={scrollToTop} className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">隐私政策</a>
            <a href="/about" onClick={scrollToTop} className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">使用条款</a>
            <a href="/about" onClick={scrollToTop} className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}